import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "onClick", "data-test-id"];
import { useMenuContext } from './VizExMenu';
import VizExMenuItemButton from './VizExMenuItemButton';
import { jsx as _jsx } from "react/jsx-runtime";
const VizExMenuItem = _ref => {
  let {
      children,
      disabled = false,
      onClick,
      'data-test-id': testId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    close
  } = useMenuContext();
  const handleClick = () => {
    if (disabled) return;
    close();
    onClick === null || onClick === void 0 || onClick();
  };
  return /*#__PURE__*/_jsx(VizExMenuItemButton, Object.assign({
    role: "menuitem",
    onClick: handleClick,
    "aria-disabled": disabled,
    "data-test-id": testId
  }, rest, {
    children: children
  }));
};
VizExMenuItem.displayName = 'VizExMenuItem';
export default VizExMenuItem;